import type { ParticipationWallItem } from "@tih/shared";
import { useSiteCopy } from "../../context/SiteCopyContext";
import { CopyText } from "../CopyText";
import { getAtPath } from "../../lib/siteCopyPaths";

type Props = {
  items: ParticipationWallItem[];
  spotlightSlug?: string;
};

export function ParticipationWall({ items, spotlightSlug }: Props) {
  const { copy } = useSiteCopy();
  const sorted = [...items].sort((a, b) => {
    if (!spotlightSlug) return 0;
    const aMatch = a.promptSlug === spotlightSlug ? 1 : 0;
    const bMatch = b.promptSlug === spotlightSlug ? 1 : 0;
    return bMatch - aMatch;
  });

  return (
    <div className="participation-wall">
      <h3 className="participation-wall-title">
        <CopyText path="home.participation.wallTitle" as="span" />
      </h3>
      {sorted.length === 0 ? (
        <p className="participation-wall-empty">
          {String(getAtPath(copy, "home.participation.wallEmpty") ?? "")}
        </p>
      ) : (
        <div className="participation-wall-track" aria-live="polite">
          {sorted.map((item) => (
            <blockquote key={item.id} className="participation-wall-card">
              <p>"{item.body}"</p>
              <footer>
                <cite>{item.name}</cite>
                <span className="participation-wall-tag">{item.promptTitle}</span>
              </footer>
            </blockquote>
          ))}
        </div>
      )}
    </div>
  );
}
